module.exports = __webpack_public_path__ + "media/images/payments/2checkout-dc17cca0bd2e05636f4747119d2ebbb9.svg";